import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { colors, theme } from "../../theme/theme";
// import { discussionsData } from "../../assets/data";
import { EastOutlined } from "@mui/icons-material";
import OnlineStatus from "../Common/OnlineStatus";
import { useNavigate } from "react-router-dom";

const Discussions = ({ allForums = [] }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 4 }}>
      <Stack
        direction={"row"}
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography sx={theme.subHeading}>
          Forums ({allForums.length})
        </Typography>
        <Typography
          sx={{
            color: colors.secondary,
            fontFamily: "Mulish-Medium",
            fontSize: "14px",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/forum`)}
        >
          See All
        </Typography>
      </Stack>

      <Box
        sx={{
          backgroundColor: "transparent",
          border: `1px solid ${colors.secondary}`,
          borderRadius: "8px",
          p: 1.5,
          mt: 1,
          overflow: "hidden",
        }}
      >
        {allForums.map((item, index) => (
          <React.Fragment key={index}>
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <img
                src={item?.image_url}
                alt="avatar1"
                style={{
                  height: "40px",
                  width: "40px",
                  borderRadius: "50%",
                }}
              />
              <Stack
                direction="column"
                justifyContent="center"
                sx={{ flex: 1, minWidth: 0 }}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems="center"
                >
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontFamily: "Mulish-SemiBold",
                        fontSize: "14px",
                      }}
                    >
                      {item?.title}
                    </Typography>

                    <OnlineStatus status={item?.status} />
                  </Stack>
                  <Typography
                    sx={{
                      color: "rgba(255, 255, 255, 0.5)",
                      fontFamily: "Mulish-Medium",
                      fontSize: "12px",
                    }}
                  >
                    @{item?.user?.firstName} {item?.user?.lastName}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {item?.categories &&
                    item?.categories?.map((tag) => (
                      <Typography
                        key={tag}
                        sx={{
                          fontSize: "12px",
                          fontFamily: "Mulish-Light",
                          color: colors.secondary,
                        }}
                      >
                        {"#" + tag}
                      </Typography>
                    ))}
                </Stack>

                <Typography
                  noWrap
                  sx={{
                    color: "rgba(255, 255, 255, 0.5)",
                    fontFamily: "Mulish-Medium",
                    fontSize: "12px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                  }}
                >
                  {item?.description}
                </Typography>
              </Stack>
            </Box>
            <Divider
              sx={{ my: 1, backgroundColor: "rgba(255,255,255,0.09)" }}
            />
          </React.Fragment>
        ))}
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 1,
            cursor: "pointer",
            height: "30px",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              borderRadius: "8px",
            },
          }}
        >
          <Typography
            sx={{
              color: colors.secondary,
              fontFamily: "Mulish-Medium",
              fontSize: "14px",
            }}
          >
            Start a Discussion
          </Typography>
          <EastOutlined sx={{ color: colors.secondary, fontSize: "18px" }} />
        </Box> */}
      </Box>
    </Box>
  );
};

export default Discussions;
